import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import {
  cleanAddress,
  processMailingAddressRule,
} from '@/store/party/partials/party-edit/helpers/pe-addresses-card'

export const PEMailingAddressCardActions = {
  initPeMailingAddressCard: ({ commit }) => {
    commit('setPeMailingAddressCardLock', true)
  },
  peMailingAddressCardRefresh: async ({ commit, getters }) => {
    const party = getters.peParty

    return axiosRequest.
      get(`/parties/${party.id}`).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeMailingAddressCardLock', true)
        commit('pePatchParty', {
          mailing_address: updatedParty.mailing_address,
          addresses: updatedParty.addresses,
        })
      }).
      catch(handleError)
  },
  peMailingAddressCardSameAsPhysical: async ({ commit, getters }, { section }) => {
    let mailingAddress = processMailingAddressRule(section)
    if (mailingAddress.same_as_physical) {
      const physicalAddress = getters.pePhysicalAddress

      mailingAddress.address = physicalAddress.address
      mailingAddress.city = physicalAddress.city
      mailingAddress.country_id = physicalAddress.country_id
      mailingAddress.county = physicalAddress.county
      mailingAddress.same_as_physical = true
      mailingAddress.state = physicalAddress.state
      mailingAddress.zip = physicalAddress.zip
    } else {
      mailingAddress = cleanAddress(section)
    }

    commit('pePatchParty', {
      mailing_address: mailingAddress,
    })
  },
  peMailingAddressCardUpdate: async ({ commit, getters }, { id, section }) => {
    const party = getters.peParty
    let address = processMailingAddressRule(section)
    if (address.same_as_physical) address = cleanAddress(address)

    return axiosRequest.
      patch(`/parties/${party.id}/addresses/${id}`, {
        address,
      }).
      then(({ data }) => {
        const addresses = data.addresses

        commit('setPeMailingAddressCardLock', true)
        commit('pePatchParty', {
          mailing_address: addresses.find(a => a.address_type === 'mailing'),
          addresses: addresses,
        })
      }).
      catch(handleError)
  },
}

export const PEMailingAddressCardMutations = {
  setPeMailingAddressCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'MailingAddressCard', lock)
  },
}

export const PEMailingAddressCardGetters = {
  peMailingAddressCardLock: state => state.partyEdit.partySections.MailingAddressCard,
}
